import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import { Formik, Form } from "formik";

interface Props {
    usuario: string;
}

export default observer(function RecuperarUsuario(props: Props) {
    const { modalStore, UsersListStore} = useStore();

    function handleFormSubmit() {
        UsersListStore.EliminarUsuario(props.usuario).then(() => {
            modalStore.closeModal()
        })
    }

    return (

        <div className="modal_pago_cur modal-reset-password">

            <div className="modal_pago_head">
                <h1>Eliminar usuario</h1>
            </div>

            <Formik
                enableReinitialize
                onSubmit={values => {
                    handleFormSubmit();
                } } initialValues={{}}>
                {({ handleSubmit, isValid, isSubmitting, dirty }) => (

                    <Form onSubmit={handleSubmit} autoComplete='off' className="contenido_modal_pago">

                        <p>¿Seguro que deseas eliminar el usuario?</p>

                        <div className="botones_pago_modal">
                            <Button
                                loading={UsersListStore.loading}
                                type='submit'
                                content={"eliminar"}
                                className="red"
                            />
                        </div>

                    </Form>
                )}
            </Formik>

        </div>

    )
})
